import { LoadPropertyPayload } from '../features/actions/loadProperties.ts';
import { CompPropertyDataState, PropertyDataState } from '../types.ts';

export const loadPropertyPayloadToPropertyData = (
  property: LoadPropertyPayload,
): PropertyDataState => {
  const { id, ...propertyData } = property;

  if (id === 'subject') return { id, subjectData: propertyData };

  return {
    id,
    compData: propertyData as CompPropertyDataState['compData'],
  };
};
